import React from 'react';
interface StatCardProps {
  title: string;
  value: string | number;
  className?: string;
}
export function StatCard({
  title,
  value,
  className = ''
}: StatCardProps) {
  return <div className={`bg-gray-50 p-3 rounded-lg text-center ${className}`} data-id="element-329">
      <div className="text-xs text-gray-500" data-id="element-330">{title}</div>
      <div className="text-lg font-semibold text-gray-900" data-id="element-331">{value}</div>
    </div>;
}